// libraries
import { useSelector } from 'react-redux';
import {
    TradeInModal,
    useCustomerVehiclesSelector,
    getIsTradeInModalVisible,
    type Deals,
    type TradeInVehicle
} from '@makemydeal/dr-activities-customer-vehicles';

// hooks
import { useTradeInsForModal } from '../hooks';

const CustomerVehiclesTradeInModal = () => {
    const { deals: groupedDeals, currentDealId, currentDealVersion } = useCustomerVehiclesSelector();
    const tradeInsForModal: TradeInVehicle[] = useTradeInsForModal();
    const isTradeInModalVisible = useSelector(getIsTradeInModalVisible) && tradeInsForModal.length > 0;

    // Find the current open deal so TradeInModal knows which trade-ins are already applied
    const currentDeal =
        groupedDeals
            ?.flatMap((group) => group.deals)
            ?.find((d) => d.dealId === currentDealId && d.version === currentDealVersion) ?? null;

    return (
        <TradeInModal
            tradeIns={tradeInsForModal}
            currentDeal={currentDeal as Deals}
            isVisibleTradeInModal={isTradeInModalVisible}
        />
    );
};

export default CustomerVehiclesTradeInModal;
